













import Vue from 'vue';

export default Vue.extend({
    name: 'RecordingBar',
    props: ['instruction'],
    data() {
        return {
            lengthHeight: 0,
            minlengthHeight: 0,
        };
    },
    mounted(): void {
        window.setTimeout(() => {
            this.lengthHeight = 100;
            this.minlengthHeight = (this.instruction.minlength / this.instruction.length) * 100;
        }, 100);
    },
});
